{
    "DAYS": "天",
    "HOURS": "小时",
    "MINUTES": "分钟",
    "SECONDS": "秒",
    "STARTING_SOON": "即将开始...",
    "DEFAULT_ERROR": "播放错误",
    "DEFAULT_ERROR_DESCRIPTION": "无法播放视频。请稍后再试。",
    "API_ERROR": "获取视频信息失败",
    "API_ERROR_DESCRIPTION": "获取视频详情时出错。请检查您的视频ID和互联网连接，然后重试。",
    "ERROR_CODE_NOT_AUTHENTICATED": "授权",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "您没有权限播放此视频。",
    "ERROR_CODE_GEO_BLOCKED": "地理封锁限制",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "抱歉，由于地理封锁限制，此视频在您的地区不可用。",
    "ERROR_CODE_NOT_ENTITLED": "无权播放",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "抱歉，您无权播放此视频。",
    "ERROR_CODE_VPN_BLOCKED": "VPN被封锁",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "由于使用VPN，此视频不可用。",
    "ERROR_CODE_IP_CHANGED": "网络已更改",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "您意外切换到了其他网络。请重试。",
    "ERROR_CODE_VPN_DETECTED": "检测到VPN",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "我们检测到VPN。请将其关闭后重试。",
    "ERROR_CODE_ANONYMOUS_PROXY": "检测到匿名代理",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "我们检测到匿名代理或服务器。请将其关闭后重试。"
}
